import { clone } from "../js/tool";
import req from "../js/req";

const lineTypes = [
  { key: 1, title: "地域线路规划" },
  { key: 2, title: "主题线路规划" },
];

const getLineTypeText = function(type) {
  const res = lineTypes.find((p) => p.key == type);
  return res ? res.title : null;
};

export default {
  name: "线路",
  listTitle: "研学线路列表",
  url: "/line", // rest接口表名
  query: "&sort=sort,-id&expand=linePoint,pointCount", // rest接口query参数
  // 列表渲染列
  columns: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { title: "线路名称", dataIndex: "name" },
      {
        title: "类型",
        dataIndex: "type",
        customRender: (text) => {
          return <span>{getLineTypeText(text)}</span>;
        },
      },
      {
        title: "路线点位",
        dataIndex: "pointCount",
        customRender: (text) => {
          return <span>{text || 0}个</span>;
        },
      },
      { title: "排序", dataIndex: "sort" },
    ];
  },
  searchKeyType: {
    name: 1,
  },
  // 列表查询表单
  queryForm: [
    {
      key: "name",
      label: "",
      component: "a-input",
      props: {
        placeholder: "请输入线路名称搜索",
        allowClear: true,
      },
      style: { width: "240px" },
    },
    {
      key: "type",
      label: "",
      component: "a-select",
      props: {
        options: lineTypes,
        placeholder: "请选择线路类型",
        allowClear: true,
      },
      style: { width: "240px" },
    },
  ],
  // 新增/编辑查询表单
  items: [
    {
      key: "name",
      label: "线路名称",
      component: "a-input",
      props: {
        placeholder: "请输入线路名称",
      },
      rules: [{ required: true, message: "请输入线路名称", trigger: "blur" }],
    },
    {
      key: "type",
      label: "线路类型",
      component: "a-select",
      props: {
        options: lineTypes,
        allowClear: true,
        placeholder: "请选择线路类型",
      },
      rules: [{ required: true, message: "请选择线路类型", trigger: "change" }],
    },
    {
      key: "linePoint",
      label: "线路点位",
      component: "line-point",
      rules: [{ required: true, message: "请选择线路点位", trigger: "change" }],
    },
    {
      key: "introduction",
      label: "线路简介",
      component: "rich-editor",
      rules: [{ required: true, message: "请输入线路简介", trigger: "blur" }],
    },
    {
      key: "sort",
      label: "排序",
      component: "a-input-number",
      props: {
        placeholder: "数字越小排位越前",
      },
      style: {
        width: "240px",
      },
    },
  ],
  init: {},
  // 详情接口expand字段
  expand: "?expand=linePoint,pointCount",
  renderItems: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { label: "线路名称", key: "name" },
      {
        label: "线路类型",
        key: "type",
        span: 2,
        slot: (entity) => {
          return <span>{getLineTypeText(entity.type)}</span>;
        },
      },
      {
        label: "线路点位",
        key: "linePoint",
        span: 3,
        slot: (entity) => (
          <a-table
            columns={[
              {
                title: "线路点位",
                dataIndex: "sort",
                customRender: (text) => {
                  return <span>点位{text}</span>;
                },
              },
              { title: "名称", dataIndex: "name" },
              { title: "地址", dataIndex: "address" },
            ]}
            data-source={entity.linePoint}
            pagination={false}
          ></a-table>
        ),
      },
      { label: "线路简介", key: "introduction", rich: true },
      { label: "排序", key: "sort" },
    ];
  },
  dealDetail(info) {
    return new Promise((resolve) => {
      info.originLinePoint = clone(info.linePoint || []);
      resolve(info);
    });
  },
  beforeUpdate: function(form) {
    return new Promise((resolve) => {
      const list = {
        add: [],
        update: [],
        delete: [],
      };
      if (form.linePoint?.length) {
        const originLinePoint = form.originLinePoint || [];
        const linePoint = form.linePoint;
        linePoint.forEach((item, index) => {
          item.lat_lon = item.location?.latLng || item.lat_lon;
          item.address = item.location?.address || item.address;
          item.sort = index + 1;
          if (item.id) {
            // 更新
            const lineIndex = originLinePoint.findIndex((o) => o.id === item.id);
            if (lineIndex > -1) {
              list.update.push(item);
              originLinePoint.splice(lineIndex, 1);
            }
          } else {
            // 新增
            list.add.push(item);
          }
        });
        list.delete = originLinePoint.map((item) => item.id).join(",");
      }
      if (form.id) {
        form.line_id = form.id;
      }
      resolve({ ...form, list });
    });
  },
  customUpdateForm(form) {
    console.log("customUpdateForm:", form);
    return req({
      url: "/line/add-line",
      method: "POST",
      data: form,
    });
  },
};
